import { FrameName } from "../config";
import AbstractPoiTileEntity from "./AbstractPoiTileEntity";

class FortressSunken4PoiTileEntity extends AbstractPoiTileEntity {
	public static readonly frameName = FrameName.FORTRESS_SUNKEN4;
}

export default FortressSunken4PoiTileEntity;
